import Image from "next/image";
import styles from "./Prefit.module.css";
import Link from "next/link";
const Prelims = () => {

    const prelimlist =[
        {list:"This is based on the model of Daily 50 questions covering the syllabus from standard books in micro sections."},
        {list:"Prefit is designed in a rigid and rigorous pattern to ensure that students develop a daily routine specific to prelims preparation"},
        {list:"We use gamification principles so as to incentivise regular test-taking and improvement of your performance."},
        {list:"We expect strict adherence to schedule with low chances of failure to comply and complete the plan."},
        {list:"This includes daily compulsory tests which have to be taken in a very strict allotted window of 2 hours permitted for you (no flexibility"},
        {list:"Each test is followed by a Daily detailed discussion ensuring you get a descriptive of the questions you attempted"},
        {list:"Exclusive test on Special Focus Areas like Schemes, Agriculture, etc"},
        {list:"Prefit is modelled on a HiiT concept where you not only cover a given syllabus in 24 hours, test your knowledge of the same in 24 hours through attempting 50 questions on that day's study target, but also validate and reinforce your knowledge of the topics through detailed discussions of the questions asked. & Much More ..."}
      ]
    
  return (
    <>

       <div className="container-fluid pt-md-3 pt-lg-4" style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
        <div className="row">
          <div className="col ps-0 pe-0">
          
              <div className="container mb-md-2 mb-xl-5">
                   <div className="row">            
                      <div className="col">
                          <h2 className={`${styles.sectiontitle} pt-3 mb-0`}>
                          How is Prefit different from Mock Tests?
                          </h2>
                            <ul className={`${styles.ulclass} ps-1 pt-2`}>
                            {prelimlist.map((item,index)=>(
                                  <li
                                    className={`${styles.ulliclass} ${styles.acheiverrank}`}
                                    id={styles.acheiverrankspecial} key={index}
                                  >
                                    <div className="d-inline">
                                      <p className={`${styles.ullispan} d-inline`}>
                                        {item.list}
                                      </p>
                                    </div>
                                  </li>
                              ))}
                            </ul>

                          
                        </div>
                        
                       
                    </div>
              </div>
        
            </div>
          </div>
        </div>

        <div className="container pt-5 p-4 p-md-0"> 
          

          <div className="row pt-md-5">
            <div className="col">
              <h2 className={`${styles.sectiontitle1} mb-0`}>Why Should you Choose Shankar IAS Prefit?</h2>
            </div>
          </div>

          <div className="row pt-3">
          <ol type="1">
            <li>
            <p className={`${styles.acheiverrank1} mb-0`}>&nbsp;What matters for a serious aspirant is the quality of questions he solves and not the quantity. As you know Shankar Ias through its pre-storming program has</p>
            <p className={`${styles.acheiverrank1}`}>&nbsp;set a standard in quality of questions, that is also reflected in actual UPSC examination.</p>
            </li>
            <li>
         <p className={`${styles.acheiverrank1} mb-0`}>&nbsp;Prefit is backed by Shankar IAS’s proprietary analytics which provides you with a detailed analysis of each of your tests. We provide analytics on overall</p>
            <p className={`${styles.acheiverrank1} mb-0`}>&nbsp;performance, relative performance, Performance by Subject, Areas to focus, Skipped or Incorrect questions Analysis, Difficulty level analysis based on exam</p>
            <p className={`${styles.acheiverrank1}`}>&nbsp;performance, Questions attempted and average time spent on such questions etc.</p>
         </li>
           
         <li>
         <p className={`${styles.acheiverrank1} mb-0`}>&nbsp;We also ensure the reliability of our online tests and rank list by using facial recognition to ensure that only the registered students appear for the exam,</p>
            <p className={`${styles.acheiverrank1}`}>&nbsp;proctor technology to ensure that students do not cheat in the exams.</p>
         </li>
            </ol>
          </div>

      </div>
 

</>
);
};

export default Prelims;